import { render, staticRenderFns } from "./ModalPDF.vue?vue&type=template&id=513c7187&scoped=true"
import script from "./ModalPDF.vue?vue&type=script&lang=js"
export * from "./ModalPDF.vue?vue&type=script&lang=js"
import style0 from "./ModalPDF.vue?vue&type=style&index=0&id=513c7187&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c7187",
  null
  
)

export default component.exports